const ITEMS = ["100% COMPOSTABLE", "ZERO PLASTIC", "GLOBAL EXPORT", "FOOD GRADE", "BULK SUPPLY", "PRIVATE LABEL"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee" className="bg-verra-light/25 border-y border-verra-green/10 py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {row.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-xl md:text-2xl text-verra-green px-8 whitespace-nowrap">{t}</span>
            <span className="text-verra-green/40">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
